// extracted by mini-css-extract-plugin
module.exports = {"tagsEmpty":"EmptyCatalogDescription__tagsEmpty","descriptionEmpty":"EmptyCatalogDescription__descriptionEmpty"};